import React from 'react';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from 'modules/store';
import Chat from 'components/pages/Chat';
import IcsChat from 'components/pages/IcsChat';
import smoothscroll from 'smoothscroll-polyfill';
import './App.css';
import dotenv from 'dotenv';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
dotenv.config({path:'../.env'});


function App() {
  smoothscroll.polyfill();
  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <Route path="/" exact component={Chat} />
{/*           <Route path="/" exact component={IcsChat} /> */}
        </Switch>
      </Router>
    </Provider>
  );
}

export default App;
